import { createFileRoute } from '@tanstack/react-router';
import { useAuth0 } from '@auth0/auth0-react';
import { useEffect } from 'react';
import { AuthShell } from '@/components/templates/AuthShell';
import { Button } from '@/components/atoms/Button';
import { getConfig } from '@/lib/config';

export const Route = createFileRoute('/register')({ component: RegisterPage });

function RegisterPage() {
  const { loginWithRedirect } = useAuth0();
  const legacyDisabled = getConfig().features.legacyLoginPageDisabled;

  // F-G1: when the legacy page is disabled, bounce straight to Auth0 hosted
  // signup. Flag off restores the in-app card with a manual continue button.
  useEffect(() => {
    if (legacyDisabled) {
      loginWithRedirect({ authorizationParams: { screen_hint: 'signup' } });
    }
  }, [legacyDisabled, loginWithRedirect]);

  if (legacyDisabled) return null;

  return (
    <AuthShell>
      <h1 className="font-display text-title text-foreground">Create your account</h1>
      <p className="mt-1 text-body-sm text-muted-foreground">Redirecting to secure signup…</p>
      <Button
        variant="tertiary"
        fullWidth
        className="mt-6"
        onClick={() => loginWithRedirect({ authorizationParams: { screen_hint: 'signup' } })}
      >
        Continue manually
      </Button>
    </AuthShell>
  );
}
